import React from 'react';
import { useUserData, FrequencyOption } from '@/context/UserDataContext';
import { getAlcoholFrequencyOptions } from '../../shared/constants';
import { FormSection } from '../../shared/FormSection';
import AnimatedSelectionGroup from '../../AnimatedSelectionGroup';

interface AlcoholConsumptionProps {
  error?: string;
  onComplete: () => void;
}

const AlcoholConsumption: React.FC<AlcoholConsumptionProps> = ({ error, onComplete }) => {
  const { userData, setUserData } = useUserData();
  const alcoholOptions = getAlcoholFrequencyOptions();

  const handleAlcoholConsumptionChange = (value: FrequencyOption) => {
    setUserData(prev => ({ ...prev, alcoholConsumption: value }));
  };

  return (
    <FormSection
      question="How often do you drink alcohol?"
      helperText="Alcohol consumption can affect nutrient absorption and liver health, which can be aided by certain supplements."
      error={error}
    >
      <AnimatedSelectionGroup
        options={alcoholOptions}
        value={userData.alcoholConsumption}
        onChange={handleAlcoholConsumptionChange}
        name="alcohol-consumption"
        onComplete={onComplete}
      />
    </FormSection>
  );
};

export default AlcoholConsumption; 